import React from 'react';
// import { Typography, Button } from '@mui/material';
// import { Link } from 'react-router-dom';
import MainGrid from './dashboard/components/MainGrid';

const HomePage = () => (
  <div style={{ textAlign: 'center', marginTop: '2rem' }}>
    <MainGrid />
  </div>
);

export default HomePage;
